module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "calibre1"
  }, [_c('p', {
    staticClass: "calibre7"
  }, [_c('br', {
    staticClass: "calibre9",
    attrs: {
      "id": "calibre_pb_5"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre16"
  }, [_c('span', {
    staticClass: "calibre4"
  }, [_vm._v("Table of Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre7"
  }, [_c('span', {
    staticClass: "calibre17"
  }, [_vm._v("Chapter 1:  I Dare You")]), _c('span', {
    staticClass: "calibre18"
  }, [_c('span', {
    staticClass: "calibre19"
  })]), _c('span', {
    staticClass: "calibre18"
  }, [_c('span', {
    staticClass: "calibre20"
  })]), _c('span', {
    staticClass: "calibre17"
  }, [_vm._v("     Pages 6 - 15")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre7"
  }, [_c('span', {
    staticClass: "calibre17"
  }, [_vm._v("Chapter 2:  The Gang’s All Here")]), _c('span', {
    staticClass: "calibre18"
  }, [_c('span', {
    staticClass: "calibre21"
  })]), _c('span', {
    staticClass: "calibre18"
  }, [_c('span', {
    staticClass: "calibre20"
  })]), _c('span', {
    staticClass: "calibre17"
  }, [_vm._v("     Pages 16 - 26 ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre7"
  }, [_c('span', {
    staticClass: "calibre17"
  }, [_vm._v("Chapter 3:  So, That Happened")]), _c('span', {
    staticClass: "calibre18"
  }, [_c('span', {
    staticClass: "calibre22"
  })]), _c('span', {
    staticClass: "calibre18"
  }, [_c('span', {
    staticClass: "calibre20"
  })]), _c('span', {
    staticClass: "calibre17"
  }, [_vm._v("     Pages 27 - 39")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre7"
  }, [_c('span', {
    staticClass: "calibre17"
  }, [_vm._v("Chapter 4:  Shifting")]), _c('span', {
    staticClass: "calibre18"
  }, [_c('span', {
    staticClass: "calibre23"
  })]), _c('span', {
    staticClass: "calibre18"
  }, [_c('span', {
    staticClass: "calibre20"
  })]), _c('span', {
    staticClass: "calibre17"
  }, [_vm._v("     Pages 40 - 61")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre7"
  }, [_c('span', {
    staticClass: "calibre17"
  }, [_vm._v("Chapter 5:  Home, Home Again")]), _c('span', {
    staticClass: "calibre18"
  }, [_c('span', {
    staticClass: "calibre24"
  })]), _c('span', {
    staticClass: "calibre18"
  }, [_c('span', {
    staticClass: "calibre20"
  })]), _c('span', {
    staticClass: "calibre17"
  }, [_vm._v("     Pages 62 - 73  ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre7"
  }, [_c('span', {
    staticClass: "calibre17"
  }, [_vm._v("Chapter 6:  Dreams")]), _c('span', {
    staticClass: "calibre18"
  }, [_c('span', {
    staticClass: "calibre25"
  })]), _c('span', {
    staticClass: "calibre18"
  }, [_c('span', {
    staticClass: "calibre20"
  })]), _c('span', {
    staticClass: "calibre17"
  }, [_vm._v("     Pages 74 - 84  ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre7"
  }, [_c('span', {
    staticClass: "calibre17"
  }, [_vm._v("Chapter 7:  At the Pond")]), _c('span', {
    staticClass: "calibre18"
  }, [_c('span', {
    staticClass: "calibre26"
  })]), _c('span', {
    staticClass: "calibre18"
  }, [_c('span', {
    staticClass: "calibre20"
  })]), _c('span', {
    staticClass: "calibre17"
  }, [_vm._v("     Pages 85 - 92")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre7"
  }, [_c('span', {
    staticClass: "calibre17"
  }, [_vm._v("Chapter 8:  Next")]), _c('span', {
    staticClass: "calibre18"
  }, [_c('span', {
    staticClass: "calibre27"
  })]), _c('span', {
    staticClass: "calibre18"
  }, [_c('span', {
    staticClass: "calibre20"
  })]), _c('span', {
    staticClass: "calibre17"
  }, [_vm._v("     Pages 93 - 121")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre7"
  }, [_c('span', {
    staticClass: "calibre17"
  }, [_vm._v("Chapter 9:")]), _c('span', {
    staticClass: "calibre28"
  }), _c('span', {
    staticClass: "calibre17"
  }, [_vm._v("Sunshine and the Star Lord Rex ")]), _c('span', {
    staticClass: "calibre18"
  }, [_c('span', {
    staticClass: "calibre29"
  })]), _c('span', {
    staticClass: "calibre18"
  }, [_c('span', {
    staticClass: "calibre20"
  })]), _c('span', {
    staticClass: "calibre17"
  }, [_vm._v("     Pages 122 – 154      Reed Dude")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre7"
  }, [_c('span', {
    staticClass: "calibre17"
  }, [_vm._v("Chapter 10:  Last Place on Earth")]), _c('span', {
    staticClass: "calibre18"
  }, [_c('span', {
    staticClass: "calibre30"
  })]), _c('span', {
    staticClass: "calibre18"
  }, [_c('span', {
    staticClass: "calibre20"
  })]), _c('span', {
    staticClass: "calibre17"
  }, [_vm._v("     Pages 155 - 176")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre7"
  }, [_c('span', {
    staticClass: "calibre17"
  }, [_vm._v("Chapter 11:  Dreams That Could Be")]), _c('span', {
    staticClass: "calibre18"
  }, [_c('span', {
    staticClass: "calibre31"
  })]), _c('span', {
    staticClass: "calibre18"
  }, [_c('span', {
    staticClass: "calibre20"
  })]), _c('span', {
    staticClass: "calibre17"
  }, [_vm._v("     Pages 177 - 179")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre7"
  }, [_c('span', {
    staticClass: "calibre17"
  }, [_vm._v("Chapter 12:")]), _c('span', {
    staticClass: "calibre28"
  }), _c('span', {
    staticClass: "calibre17"
  }, [_vm._v("Meanwhile, Back in the Now Future...")]), _c('span', {
    staticClass: "calibre18"
  }, [_c('span', {
    staticClass: "calibre32"
  })]), _c('span', {
    staticClass: "calibre17"
  }, [_vm._v("     Pages 180 - 186")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre7"
  }, [_c('span', {
    staticClass: "calibre17"
  }, [_vm._v("Chapter 13:")]), _c('span', {
    staticClass: "calibre28"
  }), _c('span', {
    staticClass: "calibre17"
  }, [_vm._v("Meanwhile, Back in the Now Future...")]), _c('span', {
    staticClass: "calibre18"
  }, [_c('span', {
    staticClass: "calibre33"
  })]), _c('span', {
    staticClass: "calibre17"
  }, [_vm._v("     Pages 187 - 217")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre7"
  }, [_c('span', {
    staticClass: "calibre17"
  }, [_vm._v("Chapter 14:  The Mill Beckons")]), _c('span', {
    staticClass: "calibre18"
  }, [_c('span', {
    staticClass: "calibre34"
  })]), _c('span', {
    staticClass: "calibre18"
  }, [_c('span', {
    staticClass: "calibre20"
  })]), _c('span', {
    staticClass: "calibre17"
  }, [_vm._v("     Pages 218 - 246")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre7"
  }, [_c('span', {
    staticClass: "calibre17"
  }, [_vm._v("Chapter 15:")]), _c('span', {
    staticClass: "calibre28"
  }), _c('span', {
    staticClass: "calibre17"
  }, [_vm._v("Meanwhile, Back in 1988 at the                    Pages 247 - 249                                   Faversham Mill Park                                                                                                       ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre7"
  }, [_c('span', {
    staticClass: "calibre17"
  }, [_vm._v("Chapter 16:  Meanwhile, Back in 2232")]), _c('span', {
    staticClass: "calibre18"
  }, [_c('span', {
    staticClass: "calibre35"
  })]), _c('span', {
    staticClass: "calibre18"
  }, [_c('span', {
    staticClass: "calibre20"
  })]), _c('span', {
    staticClass: "calibre17"
  }, [_vm._v("     Pages 250")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre7"
  }, [_c('span', {
    staticClass: "calibre17"
  }, [_vm._v("References")]), _c('span', {
    staticClass: "calibre18"
  }, [_c('span', {
    staticClass: "calibre36"
  })]), _c('span', {
    staticClass: "calibre18"
  }, [_c('span', {
    staticClass: "calibre20"
  })]), _c('span', {
    staticClass: "calibre17"
  }, [_vm._v("     Page 251")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre7"
  }, [_c('span', {
    staticClass: "calibre17"
  }, [_vm._v("Author Bio")]), _c('span', {
    staticClass: "calibre18"
  }, [_c('span', {
    staticClass: "calibre37"
  })]), _c('span', {
    staticClass: "calibre18"
  }, [_c('span', {
    staticClass: "calibre20"
  })]), _c('span', {
    staticClass: "calibre17"
  }, [_vm._v("     Page 252")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre7"
  }, [_c('span', {
    staticClass: "calibre8",
    attrs: {
      "id": "calibre_pb_6"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-06e827e2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/part0000_split_003.vue
// module id = 69
// module chunks = 0